module.exports = __webpack_public_path__ + "static/media/rl-selector-color.e66ed7f6.png";